import { Sprite } from 'pixi.js';
import { IMAGES, MainSignals } from '../../../../settings/constants';
import { SCENE_5 } from '../../../../settings/positions';
import SceneBase from '../base/SceneBase';

export default class Scene5 extends SceneBase {
  constructor(signals: MainSignals) {
    super(signals, SCENE_5, 5, 5, false);

    // parts
    const bg = Sprite.from(IMAGES.BG_5);
    bg.anchor.set(0.5);
    this.addChild(bg);
  }
}
